import { useMemo, useState } from 'react';
import { MeasurementRange } from '../../common/chart/types/types';
import type { ProviderCommonProps } from '../../../types/provider.types';
import { getDateRangeByPage } from '../../common/chart/utils/date-range';
import type { MeterDataContextType } from './types';
import { MeterDataContext } from './context';

export const MeterDataProvider = ({ children }: ProviderCommonProps) => {
  const [selectedRange, updateSelectedRange] = useState<MeasurementRange>(MeasurementRange.DayInHours);
  const [page, setPage] = useState(0);

  const fromTo = useMemo(() => getDateRangeByPage(selectedRange, page), [selectedRange, page]);

  const setSelectedRange = (range: MeasurementRange) => {
    updateSelectedRange(range);
    setPage(0);
  };

  const value: MeterDataContextType = {
    selectedRange,
    setSelectedRange,
    page,
    setPage,
    fromTo,
  };

  return <MeterDataContext.Provider value={value}>{children}</MeterDataContext.Provider>;
};
